import React, { useEffect } from 'react'
import { OptionProps } from '../Option'

interface Props<ValueType = string> {
  active: boolean
  children: React.ReactNode
  cursor: number
  input: {
    downPress: boolean
    escPress: boolean
    upPress: boolean
  }
  items: OptionProps<ValueType>[]
  onClose: () => void
  onCursorChange: (index: number) => void
}

export const findNextIncrement = function <T>(cursor: number, items: OptionProps<T>[]) {
  if (cursor < 0) {
    return 0
  }
  const slicedItems = items.slice(cursor + 1)
  const nextIndex = slicedItems.findIndex(item => (item.hidden || item.disabled ? false : true))
  return cursor + nextIndex + 1
}

export const findPreviousIncrement = function <T>(cursor: number, items: OptionProps<T>[]) {
  const slicedItems = items.slice(0, cursor).reverse()
  const nextIndex = slicedItems.findIndex(item => (item.hidden || item.disabled ? false : true))
  return cursor - nextIndex - 1
}

export const CursorManager = <ValueType extends unknown = string>({
  items,
  input,
  onCursorChange,
  onClose,
  cursor,
  children,
  active,
}: Props<ValueType>) => {
  useEffect(() => {
    if (input.escPress && active) {
      onClose()
    }
  }, [input.escPress, onClose, active])

  useEffect(() => {
    const moveToNextItem = () => {
      if (items.length > 0 && input.downPress && active) {
        onCursorChange(cursor < items.length - 1 ? findNextIncrement(cursor, items) : cursor)
      }
    }

    moveToNextItem()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.downPress])

  useEffect(() => {
    const moveToPreviousItem = () => {
      if (items.length && input.upPress && active) {
        onCursorChange(cursor > 0 ? findPreviousIncrement(cursor, items) : cursor)
      }
    }

    moveToPreviousItem()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.upPress])

  return <>{children}</>
}
